import config from '../config';
import { NON_US_REGION, US_REGION } from './app-legal-regions';

const APP_UI_CONFIG = {
    legalLinks: {
        [US_REGION]: {
            termsOfUse: `${config.platformUrl}/terms-of-use-boundly-us.html`,
            privacyPolicy: `${config.platformUrl}/privacy-policy-boundly-us.html`,
            cookiePolicy: `${config.platformUrl}/cookie-policy-boundly.html`
        },
        [NON_US_REGION]: {
            termsOfUse: `${config.platformUrl}/terms-of-use-boundly-non-us.html`,
            privacyPolicy: `${config.platformUrl}/privacy-policy-boundly-non-us.html`,
            cookiePolicy: `${config.platformUrl}/cookie-policy-boundly.html`
        }
    },
    legalEntity: {
        [US_REGION]: {
            year: 2025,
            company: 'Futureproof Limited',
            address: '9805 Double R Blvd, Suite 300, Reno, Nevada, 89521, USA',
            telephone: {
                link: 'tel:+14244245570',
                text: '+1 (424) 424-5570'
            }
        },
        [NON_US_REGION]: {
            year: 2021,
            company: 'Jorefil Limited',
            address: '1st Floor, Georgiou Christoforou 8, 2012, Strovolos, Nicosia, Cyprus, Reg. number ΗΕ 450467, VAT number 60027685N, Department of Registrar of Companies and Official Receiver'
        }
    }
};

const getLegalLinks = region => APP_UI_CONFIG.legalLinks?.[region] || APP_UI_CONFIG.legalLinks[NON_US_REGION];
const getLegalEntity = region => APP_UI_CONFIG.legalEntity?.[region] || APP_UI_CONFIG.legalEntity[NON_US_REGION];

export {
    APP_UI_CONFIG,
    getLegalLinks,
    getLegalEntity
};
